import React from "react"

import { Color } from "../../../../../constants/V2/color"
import Typography from "../../../../elements/V2/Typography"

type PayflexStepProps = {
  stepCount: number
  label: string
}

const PayflexStep = ({ stepCount, label }: PayflexStepProps) => {
  return (
    <div className="flex flex-row items-center gap-10 md:flex-col">
      <div className="flex min-h-32 min-w-32 items-center justify-center gap-16 rounded-full bg-payflex-purple md:h-[100px] md:w-[100px] md:gap-0 md:p-20">
        <Typography
          weight="book"
          color={Color.PayflexNavy}
          font="grotesk"
          size="h3"
          text={stepCount.toString()}
          className="hidden md:block"
        />
        <Typography
          weight="book"
          color={Color.PayflexNavy}
          font="grotesk"
          size="body-lg-fixed"
          text={stepCount.toString()}
          className="md:hidden"
        />
      </div>
      <Typography
        weight="book"
        color={Color.PayflexNavy}
        font="grotesk"
        size="body-sm"
        text={label}
        className="md:w-[180px] md:text-center"
      />
    </div>
  )
}

export default PayflexStep
